import { render, staticRenderFns } from "./hearing-aid.vue?vue&type=template&id=d4d3a55e&scoped=true&"
import script from "./hearing-aid.vue?vue&type=script&lang=js&"
export * from "./hearing-aid.vue?vue&type=script&lang=js&"
import style0 from "./hearing-aid.vue?vue&type=style&index=0&id=d4d3a55e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d3a55e",
  null
  
)

export default component.exports